import WAboutCompareDetailsDesktop from './WAboutCompareDetailsDesktop'

export default WAboutCompareDetailsDesktop
